
import React from "react"
import { Helmet } from "react-helmet"
export const Seo = ({ title, description, image, article , seoTitle , lang=false}) => {


     const   defaultTitle = '20k'
     const   defaultDescription = '20k website '
     const   defaultImage = ''

  const seo = {
    title:seoTitle + " | " +  title || defaultTitle,
    description: description || defaultDescription,
    image:   image || defaultImage  ,
  }


  return (
    <Helmet   htmlAttributes={lang?{
      lang
    }:{}} title={seo.title}  >
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      {seo.url && <meta property="og:url" content={seo.url} />}
      {(article ? true : null) && <meta property="og:type" content="article" />}
      {seo.title && <meta property="og:title" content={seo.title} />}
      {seo.description && (
        <meta property="og:description" content={seo.description} />
      )}
      {seo.image && <meta property="og:image" content={seo.image} />}
      <meta name="twitter:card" content="summary_large_image" />
      {/*{twitterUsername && (*/}
      {/*  <meta name="twitter:creator" content={twitterUsername} />*/}
      {/*)}*/}
      {seo.title && <meta name="twitter:title" content={seo.title} />}
      {seo.description && (
        <meta name="twitter:description" content={seo.description} />
      )}
      {seo.image && <meta name="twitter:image" content={seo.image} />}
      <meta property="fb:app_id" content="1648759022060115"/>
    </Helmet>
  )
}

